import type { Issue, IssueSeverity } from '../types/issue';

export const ISSUE_SLA_DAYS: Record<IssueSeverity, number> = {
  critical: 3,
  high: 7,
  medium: 14,
  low: 30,
};

export function getIssueSlaDays(severity: IssueSeverity): number {
  return ISSUE_SLA_DAYS[severity] ?? 14;
}

export function getDaysSinceCreated(createdAt: string): number {
  return Math.floor((Date.now() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24));
}

export function getSlaRemainingDays(
  severity: IssueSeverity,
  createdAt: string,
  status?: Issue['status'],
): number {
  if (status === 'closed') return Number.POSITIVE_INFINITY;
  return getIssueSlaDays(severity) - getDaysSinceCreated(createdAt);
}

export function isSlaOverdue(issue: Pick<Issue, 'severity' | 'created_at' | 'status'>): boolean {
  if (issue.status === 'closed') return false;
  return getSlaRemainingDays(issue.severity, issue.created_at, issue.status) < 0;
}

export function isSlaWarning(issue: Pick<Issue, 'severity' | 'created_at' | 'status'>): boolean {
  if (issue.status === 'closed') return false;
  const remaining = getSlaRemainingDays(issue.severity, issue.created_at, issue.status);
  return remaining >= 0 && remaining <= 2;
}
